<div class="container-full" style="margin-top:10px;">
    <app-header-title-lot-data
    [title]="'Payment Report'"
    [lotNumber]="_appGeneralState.currentLotNumber"
    [lotName]="_appGeneralState.currentLotName"
></app-header-title-lot-data>
    
    <mat-card style="margin-top:30px;margin-left:10px;margin-right:0px;width:99%;height:90%;min-height: 600px;">
        <mat-card-header>
        
        </mat-card-header>    
        <mat-card-content>
                <form 
                (ngSubmit)="onFindInvoicePayments()" 
                novalidate
                [formGroup]="paymentSearchForm" 
                style="margin-top:20px;">
            <div class="row" style="width:100%;">
                <div class="col-6">
                    <app-date-selection (dateOutput)="onHandleQueryData($event)"></app-date-selection>
                 </div>
                 <div class="col-3">
                    <mat-form-field appearance="fill" style="width:100%">
                        <mat-label>Tenant Name</mat-label>
                        <input matInput placeholder="Tenant Name"  formControlName="tenantName" autocomplete="chrome-off" maxlength="32">
                        <!-- <mat-error>The last name is required</mat-error> -->
                      </mat-form-field>
                </div>
                 <div class="col-3">
                    <mat-form-field appearance="fill" style="width:100%;color:gray">
                        <mat-label>Payment Type:</mat-label>
                        <mat-select formControlName="paymentCode">
                          <mat-option value="0">All Payment Types</mat-option>
                          <mat-option value="1">Space Portal Payments</mat-option>
                          <mat-option value="2">Non Space Portal Payments</mat-option>
                        </mat-select>
                      </mat-form-field>          
                </div>
            </div>
            <div class="row" style="width:100%;margin-top:2px;">
                <div class="col-12">
                    <button type="submit" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;" [disabled]="!paymentSearchForm.valid">Search</button>
                    <button type="button" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;" (click)="onClearSearchCriteria()">Clear</button>
                </div>    
            </div>
        </form>

        <ng-container *ngIf="queryInProcess">
            <div class="row mt-3" >
                <div class="col-12 text-center">
                    <span><strong>Stand by while we load the data for the Payment Report...</strong></span>
                </div>
            </div>
            <div style="margin-top:30px;">
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                
            </div>
        </ng-container>

        <ng-container *ngIf="!queryCompleted && queryInProcess == false">
            <div style="margin-top:30px;margin-left:20px;">
                <strong>Click Search to find data for the Payment Report</strong>
            </div>
        </ng-container>

        <ng-container *ngIf="queryCompleted && paymentReportDisplayData.length == 0">
            <div style="margin-top:30px;margin-left:20px;">
                <strong>No data found matching this search criteria</strong>
            </div>
        </ng-container>

        <ng-container *ngIf="this.paymentReportData.length > 0">
            <div style="margin-top:30px;"></div>
            <div class="ace-heading-text-secondary" style="font-size:21px;margin-left:10px;">
               Payments Located: {{paymentReportData.length}}
               @if(paymentReportData.length == 1000){
                <br />
                <span style="font-size: 14px;font-family:Arial, Helvetica, sans-serif;font-weight: normal;">(Report display limited to 1,000 payments)</span>
               }
            </div>
            <igx-grid #gridParkersV2MainGridzzz id="gridParkersV2MainGridzzz" [data]="paymentReportDisplayData" [width]="'99%'" [height]="'2000px;'" [autoGenerate]="false" style=margin-left:10px;margin-top:10px;
paste-handler  [primaryKey]="'parkerId'" [rowEditable]="false" [allowFiltering]="true"  filterMode="excelStyleFilter" displayDensity="compact" 
[emptyGridMessage]="'No Payment Data Found'"  paste-handler   >

<igx-column field="lotNumber" header="Lot No." width="125px" required [sortable]="true" ></igx-column>

<igx-column field="customerType" header="Type" width="100px" required [sortable]="true" ></igx-column>

<igx-column field="revenueDate" header="Revenue Date" width="150px" required [sortable]="true" >
    <ng-template igxCell let-value let-cell="cell">
        <div class="cell__inner">
                {{value}}
        </div>
    </ng-template>
</igx-column>

<igx-column field="invoiceNumber" header="Invoice No.*" [sortable]="true" width="200px">
    <ng-template igxCell let-value let-cell="cell">
        <div class="cell__inner">
              <a href="" (click)="onDisplayInvoice(cell.row.data.invoiceNumber, cell.row.data.lotNumber, cell.row.data.entityId); $event.preventDefault()" style="color:#1976d2;text-decoration:underline;cursor:pointer;">
                        {{cell.value}}
                </a>
        </div>
    </ng-template>
</igx-column>

<igx-column field="dueDate" header="Due Date" width="150px" required [sortable]="true" >
    <ng-template igxCell let-value let-cell="cell">
        <div class="cell__inner">
            {{value}}
        </div>
    </ng-template>
</igx-column>

<igx-column field="customer" header="Customer" width="150px" required [sortable]="true" ></igx-column>

<igx-column field="depositDate" header="Deposit Date" width="150px" required [sortable]="true" >
    <ng-template igxCell let-value let-cell="cell">
        <div class="cell__inner">
            {{value}}
        </div>
    </ng-template>
</igx-column>

<igx-column field="transactionDate" header="Transaction Date" width="150px" required [sortable]="true" >
    <ng-template igxCell let-value let-cell="cell">
        <div class="cell__inner">
            {{value}}
        </div>
    </ng-template>
</igx-column>


<igx-column field="amount" header="Paid Amount" width="150px" required [sortable]="true" >
    <ng-template igxCell let-value let-cell="cell">
        <div class="cell__inner">
            @if(value < 0){
                <span style="color:red">({{ value | currency}})</span>
            }
            @else {
                {{ value | currency}}
            }
                
        </div>
    </ng-template>
</igx-column>
<igx-column field="paymentCode" header="Payment Code" width="150px" required [sortable]="true" ></igx-column>
<igx-column field="filterDescription" header="Description" width="150px" required [sortable]="true" ></igx-column>
<igx-column field="referenceNumber" header="Reference Number" width="150px" required [sortable]="true" ></igx-column>
<igx-column field="userName" header="User Name" width="150px" required [sortable]="true" ></igx-column>
<igx-column field="paymentScheduleType" header="Payment Type" width="150px" required [sortable]="true" ></igx-column>

<igx-column field="comments" header="Comments" width="350px" required [sortable]="true" ></igx-column>

<igx-grid-toolbar>
    <igx-grid-toolbar-actions>
        <igx-grid-toolbar-pinning></igx-grid-toolbar-pinning>
        <igx-grid-toolbar-hiding></igx-grid-toolbar-hiding>
        <igx-grid-toolbar-exporter></igx-grid-toolbar-exporter>
    </igx-grid-toolbar-actions>
</igx-grid-toolbar>

</igx-grid>
        </ng-container>

        </mat-card-content>
        <mat-card-actions style="margin-top:20px;">
            
      </mat-card-actions>
  
    </mat-card>                                                                             

</div>


